import { ITextAboveUnderMedia } from 'Scripts/Types/Litium';
import Markup from 'Components/Markup';

interface CreativeTextProps extends ITextAboveUnderMedia {
    isAboveText: boolean;
    mobileCenterText: boolean;
}

const CreativeText = ({
    text,
    centerTextBetweenColumns,
    textWidth,
    isAboveText,
    mobileCenterText,
}: CreativeTextProps) => {
    const containerStyle = centerTextBetweenColumns
        ? `${
              mobileCenterText
                  ? 'w-[calc(200%+var(--block-margin))] lg:w-[calc(200%+var(--block-margin-desktop)/2)] text-center translate-x-[calc(-50%-var(--block-margin)/2)] lg:translate-x-[calc(-50%-var(--block-margin-desktop)/2)] max-w-[calc(100vw-var(--block-margin)*2)] lg:max-w-none'
                  : 'lg:w-[calc(200%+var(--block-margin-desktop))] text-center lg:translate-x-[calc(-50%-var(--block-margin-desktop)/2)]'
          }`
        : '';

    return (
        text?.value && (
            <Markup
                html={text.value}
                cssClass={`prose-block relative mx-auto px-4 lg:px-0 ${containerStyle} w-full 
            lg:w-[var(--block-text-width)] ${
                isAboveText ? 'mb-3 mt-0' : 'mt-3 mb-0'
            }`}
                style={
                    {
                        '--block-text-width': `${textWidth}%`,
                    } as React.CSSProperties
                }
            />
        )
    );
};

export default CreativeText;
